var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgInsuranceCancellationSuccess = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 112 112",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#InsuranceCancellationSuccess_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M62.542 37.032C54.805 23.63 37.668 19.038 24.266 26.776 10.864 34.513 6.272 51.65 14.01 65.052l12.665 21.936c7.738 13.402 24.874 17.994 38.276 10.256 13.402-7.737 17.994-24.874 10.256-38.276L62.542 37.032Z",
  fill: "#D80073"
}), /*#__PURE__*/React.createElement("path", {
  d: "M64.11 72.26c-3.17-12.22-15.65-19.55-27.87-16.38l-23.73 6.16c.44 1.02.93 2.02 1.5 3.01l12.67 21.94c4.3 7.46 11.52 12.18 19.38 13.58l1.68-.44c12.22-3.17 19.55-15.65 16.38-27.87h-.01Z",
  fill: "#FF59C1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M109.51 37.89c-1.15-.58-2.36-.93-3.56-.91.44-1.95-.5-3.91-2.35-4.85-1.1-.55-2.26-.81-3.4-.82-.09-1.53-.95-2.97-2.42-3.71a7.76 7.76 0 0 0-10.48 3.57l-6.37 13.78-.04-.04-20.84-.07 1.71-8.04c.96-4.52-1.05-9.15-5-11.54-3.18-1.92-7.31-.19-8.18 3.42l-3.25 13.55c-3.51 14.61 7.57 28.65 22.59 28.65h14.85c9.86 0 18.83-5.72 22.98-14.67l5.79-12.48c1.01-2.17.11-4.75-2.03-5.83v-.01Z",
  fill: "#fff",
  stroke: "#D80073",
  strokeWidth: 0.75,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M103.81 32.22a7.76 7.76 0 0 0-10.48 3.57l-6.67 14.1M109.51 37.89a7.76 7.76 0 0 0-10.48 3.57l-6.67 14.1",
  stroke: "#D80073",
  strokeWidth: 0.75,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M71.89 1.37c-.12.03-3.05.8-3.17.84a22.876 22.876 0 0 0-9.94 5.91c-8.93 9.02-8.86 23.58.16 32.51 6.1 6.04 14.72 7.96 22.42 5.79.09-.03 2.77-.73 2.86-.76 3.6-1.06 4.4-2.34 7.23-5.19 8.93-9.02 8.86-23.58-.16-32.51-6.04-5.98-11.75-8.66-19.4-6.59Z",
  fill: "#D80073",
  stroke: "#D80073",
  strokeWidth: 0.75,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M80.07 45.98c12.697 0 22.99-10.293 22.99-22.99S92.767 0 80.07 0 57.08 10.293 57.08 22.99s10.293 22.99 22.99 22.99Z",
  fill: "#FF59C1",
  stroke: "#D80073",
  strokeWidth: 0.75,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M94.212 13.756c-1.085-1.008-2.839-1.008-3.923 0l-12.942 12.03-6.61-6.144c-1.085-1.008-2.839-1.008-3.923 0-1.085 1.008-1.085 2.638 0 3.646l8.565 7.962a2.86 2.86 0 0 0 1.955.75 2.86 2.86 0 0 0 1.955-.75l14.897-13.847c1.085-1.009 1.085-2.638 0-3.647h.026ZM92.27 55.58 81.54 54.2a32.984 32.984 0 0 0-23.65 6.06",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M92.27 55.58 81.54 54.2a32.984 32.984 0 0 0-23.65 6.06",
  stroke: "#D80073",
  strokeWidth: 0.75,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "InsuranceCancellationSuccess_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h111.954v111.254H0z"
})))));

export default SvgInsuranceCancellationSuccess;